import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "back-icon--sprite",
  "use": "back-icon--sprite-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\" id=\"back-icon--sprite\">\n  <path d=\"M 26.292969,17.292969 19.585937,24 26.292969,30.707031 27.707031,29.292969 22.414062,24 27.707031,18.707031 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol